module.exports = __webpack_public_path__ + "img/detail6.9803636d.png";